import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Field } from 'redux-form';
import HookFormField from 'spark-ui/form/hookFormAdapter';
import DatePicker from 'react-datepicker';
import get from 'lodash/get';
import { inputMixin } from 'spark-ui/ui-kitchen/ingredients/veggies/fields/inputs/Input';
import InputLabel from 'spark-ui/ui-kitchen/ingredients/spices/InputLabel';
import InputErrorMessage from 'spark-ui/ui-kitchen/ingredients/spices/text/InputErrorMessage';
import 'react-datepicker/dist/react-datepicker.css';

const Container = styled.div`
	display: inline-block;

	& > div {
		display: inline-block;
	}

	& .separator {
		margin: 0 7px;
		font-size: 13px;
		align-self: center;
	}
`;

const DatePickerInput = styled(DatePicker)`
    && {
        ${inputMixin};
        min-width: 7em;
        width: 7em;
		border-radius: 4px;
		padding: 8px;
		height: auto;
    }
`;

const toDateObj = (val) => {
	if (!val) return null;
	if (val instanceof window.Date) return val;
	const parsed = new window.Date(val);
	return isNaN(parsed.getTime()) ? null : parsed;
};

const DateRange = ({ showReqMessage = true, disabled, label, inlineLabel, input, meta: { touched, error } }) => {
	const initialValue = get(input, 'value', {});
	const [start, setStart] = useState(() => toDateObj(initialValue.start));
	const [end, setEnd] = useState(() => toDateObj(initialValue.end));

	const handleDateChange = useCallback((date, modifiedField) => {
		if (modifiedField === 'start') {
			setStart(date);
			input.onChange({ ...input.value, start: date, end });
		} else {
			setEnd(date);
			input.onChange({ ...input.value, start, end: date });
		}
	}, [start, end, input]);

	const handleStartChange = (date) => handleDateChange(date, 'start');
	const handleEndChange = (date) => handleDateChange(date, 'end');

	return (
		<Container>
			{label && <InputLabel style={{ fontSize: '13px' }} inline={inlineLabel}>{label}</InputLabel>}
			<div style={{ display: 'flex' }}>
				<DatePickerInput
					selectsStart
					selected={start}
					maxDate={end}
					disabled={disabled}
					dateFormat="dd-MMM-yyyy"
					placeholderText="Start"
					onChange={handleStartChange}
				/>
				<span className="separator">to</span>
				<DatePickerInput
					selectsEnd
					selected={end}
					minDate={start}
					disabled={disabled}
					dateFormat="dd-MMM-yyyy"
					placeholderText="End"
					onChange={handleEndChange}
				/>
			</div>
			{touched && showReqMessage && <InputErrorMessage>{error}</InputErrorMessage>}
		</Container>
	);
};

const DateRangeField = (props) => {
	const { control, ...rest } = props;
	if (control) {
		return <HookFormField {...rest} control={control} component={DateRange} />;
	}
	return <Field {...rest} component={DateRange} />;
};

export default DateRangeField;
